import {field} from '../field'
import {mergeConfig} from '../../configStore'
import {BlockField, FieldReturn} from '../../types'

export const block = (props?: BlockField, mergeProps?: Partial<BlockField>): FieldReturn =>
  field('block', mergeConfig('block', props, mergeProps))
